///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { odLoadingTypes as serviceType } from "./types";
import messages from "./messages";

export const mapOdLoadingTypes = odLoadingTypes => {
  let multiSelectOdLoadingTypes = [];

  if (
    odLoadingTypes -
      serviceType.find(x => x.label === messages.dropOrDrop.defaultMessage)
        .value >=
    0
  ) {
    multiSelectOdLoadingTypes.push(
      serviceType.find(x => x.label === messages.dropOrDrop.defaultMessage)
    );
    odLoadingTypes -= serviceType.find(
      x => x.label === messages.dropOrDrop.defaultMessage
    ).value;
  }

  if (
    odLoadingTypes -
      serviceType.find(x => x.label === messages.dropOrLive.defaultMessage)
        .value >=
    0
  ) {
    multiSelectOdLoadingTypes.push(
      serviceType.find(x => x.label === messages.dropOrLive.defaultMessage)
    );
    odLoadingTypes -= serviceType.find(
      x => x.label === messages.dropOrLive.defaultMessage
    ).value;
  }

  if (
    odLoadingTypes -
      serviceType.find(x => x.label === messages.liveOrDrop.defaultMessage)
        .value >=
    0
  ) {
    multiSelectOdLoadingTypes.push(
      serviceType.find(x => x.label === messages.liveOrDrop.defaultMessage)
    );
    odLoadingTypes -= serviceType.find(
      x => x.label === messages.liveOrDrop.defaultMessage
    ).value;
  }

  if (
    odLoadingTypes -
      serviceType.find(x => x.label === messages.liveOrLive.defaultMessage)
        .value >=
    0
  ) {
    multiSelectOdLoadingTypes.push(
      serviceType.find(x => x.label === messages.liveOrLive.defaultMessage)
    );
  }

  return multiSelectOdLoadingTypes;
};
